import {Injectable} from '@angular/core';
import {Action, State, StateContext, StateToken, Store} from '@ngxs/store';

import {QUERYABLE_STATE_MODEL_DEFAULTS, QueryableState, QueryableStateModel} from '../../../../common/state/queryable.state';
import {QueryBuilder} from "../../../../common/query/query.builder";
import {UpdateInventorySummaryActiveSiderSection} from "./inventory-summary.actions";

const INVENTORY_SUMMARY_STATE_TOKEN = new StateToken<InventorySummaryStateModel>('inventory_summary');

export interface InventorySummaryStateModel extends QueryableStateModel<any> {

}

@State<InventorySummaryStateModel>({
  name: INVENTORY_SUMMARY_STATE_TOKEN,
  defaults: {...QUERYABLE_STATE_MODEL_DEFAULTS},
})
@Injectable()
// @ts-ignore
export class InventorySummaryState extends QueryableState {
  constructor(
    public store: Store,
    public queryBuilder: QueryBuilder,
  ) {
    super(store, queryBuilder);
  }

  // @ts-ignore
  @Action(UpdateInventorySummaryActiveSiderSection)
  updateInventorySummaryActiveSiderSection(ctx: StateContext<any>, action: any): void {
    ctx.patchState({
      activeSiderSection: action.name || null
    })
  }
}
